import axios from "axios";
import VueCookies from "vue-cookies";
import { GetQueryValue1 } from "./utils";
let qs = require("qs");

axios.defaults.withCredentials = true;

let host = window.location.hostname;

// let _baseUrl = `10.107.13.36/nursingApi`; //生产分支配置
let _baseUrl = `ebn.nursing.fudan.edu.cn/nursingApi/`; //胡恩伟
// let _baseUrl = `192.168.0.102:8501/fdNursing`; //洪松

let baseUrl = `http://${_baseUrl}`;

/**
 * get 请求
 */
const httpGet = async function(url = "", data = {}, type) {
  let _token = GetQueryValue1("nursing_tokenWeb");
  if (!_token) {
    _token = VueCookies.get("nursing_tokenWeb");
  }
  const instance = axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json;charset=UTF-8",
      "content-type": "application/json",
      Authorization: _token ? "Bearer " + _token : ""
    }
  });
  return instance
    .get(url, {
      params: data
    })
    .then(result => {
      var res = result.data;
      if (res && res.code === 0) {
        return Promise.resolve(res);
      } else {
        if (res.code === 15000) {
          this.$message({
            message: "系统异常",
            type: "warning"
          });
          return res;
        } else if (res.code === 10000) {
          this.$message({
            message: res.message,
            type: "warning"
          });
          return res;
        } else if (res.code === 10010) {
          this.$message({
            message: res.message,
            type: "warning"
          });
          this.$router.push("/home");
          return res;
        } else if (res.code == 10001 || res.code == 10002) {
          if (res.data) {
            this.$message({
              message: res.data.message,
              type: "warning"
            });
            this.$cookies.remove("nursing_tokenWeb");
            this.$cookies.remove("tokenWebRefresh");
            this.$cookies.remove("nursing_userInfo");
          } else {
            this.$message({
              message: "登录信息已失效,请重新登录",
              type: "warning"
            });
          }
          this.$router.push("/login");
          return res;
        }
        return Promise.resolve(res);
      }
    })
    .catch(error => {
      let res = error.response;
      if (res.status === 400 || res.status === 401) {
        if (res.data) {
          this.$message({
            message: res.data.message,
            type: "warning"
          });
          this.$cookies.remove("nursing_tokenWeb");
          this.$cookies.remove("tokenWebRefresh");
          this.$cookies.remove("nursing_userInfo");
        } else {
          this.$message({
            message: "登录信息已失效,请重新登录",
            type: "warning"
          });
        }
        this.$router.push("/login");
        return res;
      } else if (res.status === 500) {
      }
      res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！"
      };
      return res;
    });
};
/**
 * post 请求
 */
const httpPost = async function(url = "", data = {}, type) {
  let _token = GetQueryValue1("nursing_tokenWeb");
  if (!_token) {
    _token = VueCookies.get("nursing_tokenWeb");
  }
  const instance = axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json;charset=UTF-8",
      "content-type": "application/json",
      Authorization: _token ? _token : ""
    }
  });
  return instance
    .post(url, JSON.stringify(data))
    .then(result => {
      var res = result.data;
      if (res && res.code === 0) {
        return Promise.resolve(res);
      } else {
        if (res.code === 15000) {
          return res;
        }  else if (res.code === 10010) {

          this.$router.push("/home");
          return res;
        }else if (res.code == 10001 || res.code == 10002) {
          if (res.data) {
            this.$message({
              message: res.data.message,
              type: "warning"
            });
          } else {
            this.$message({
              message: "登录信息已失效,请重新登录",
              type: "warning"
            });
          }
          this.$cookies.remove("nursing_tokenWeb");
          this.$cookies.remove("tokenWebRefresh");
          this.$cookies.remove("nursing_userInfo");
          this.$router.push("/login");
          return res;
        }
        return res;
      }
    })
    .catch(error => {
      let res = error.response;
      if (res.status === 400 || res.status === 401) {
        if (res.data) {
          this.$message({
            message: res.data.message,
            type: "warning"
          });
          this.$cookies.remove("nursing_tokenWeb");
          this.$cookies.remove("tokenWebRefresh");
          this.$cookies.remove("nursing_userInfo");
        } else {
          this.$message({
            message: "登录信息已失效,请重新登录",
            type: "warning"
          });
        }
        this.$router.push("/login");
        return res;
      } else if (res.status === 500) {
      }
      res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！"
      };
      return res;
    });
};

/**
 * 认证请求
 */
const httpPostToken = function(url = "", data) {
  const instance = axios.create({
    baseURL: baseUrl,
    withCredentials: false,
    headers: {
      Authorization: "Basic bW9uZXR3YXJlOm1vbmV0d2FyZTIwMTkuQHNoLmNvbQ==",
      "content-type": "application/json"
    }
  });
  return instance
    .post(url, data)
    .then(result => {
      var res = result.data;
      if (result && result.status === 200) {
        if (res != null && res.token != null && res.token != "") {
          this.$cookies.set("nursing_tokenWeb", res.token, 24 * 60 * 60);
          // this.$cookies.set("tokenWebRefresh", res.refresh_token, 25 * 60 * 60);
    
          res = {
            code: 0,
            message: "登录成功"
          };
          return Promise.resolve(res);
        } else {
          if (res) {
            res = {
              code: res.code,
              message: res.message
            };
          } else {
            res = {
              code: -1,
              message: "res.messages认证失败，请联系客服人员！"
            };
          }
          return res;
        }
      }
    })
    .catch(error => {
      let res = error.response;
      // console.log(res);
      if (res.status === 400 || res.status === 401 || res.status === 500) {
        res = {
          code: res.data.code,
          message: res.data.message
        };
        return res;
      }
      res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！"
      };
      return res;
    });
};

export { baseUrl, baseAuthUrl, httpGet, httpPost, httpPostToken };



// WEBPACK FOOTER //
// ./src/utils/httpService.js